import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
    // BrowserRouter as Router,
    Switch,
    Route,
    useLocation
} from "react-router-dom";

import Highcharts from 'highcharts/highstock';
// import HighchartsExporting from  'highcharts/modules/exporting';
// import HighchartsExportData from 'highcharts/modules/export-data';
import HighchartsNoDataToDisplay from 'highcharts/modules/no-data-to-display';
import HighchartsHeatmap from "highcharts/modules/heatmap";
import HighchartsTreemap from "highcharts/modules/treemap";
import HighchartsWordcloud from "highcharts/modules/wordcloud";
import HighchartsMore from "highcharts/highcharts-more";

// For MSAL 2...
import authService from "./redux/auth/authService";


// Material UI
import { StyledEngineProvider, adaptV4Theme } from '@mui/material/styles';

// App Layout
import Routes from './Routes';
import AppLoading from './components/loading/AppLoading';
import UnsupportedBrowserLayout from './components/unsupported/UnsupportedBrowserLayout';
import UnauthorizedLayout from './components/unauthorized/UnauthorizedLayout';

import './App.css';
import './prototypes';

import {
    appSetPreviousRoute,
    appSetAlert, appSetModalContent
} from "./redux/app/appActions";

import {
    authInitialize
} from "./redux/auth/authActions";

import {
    configLoad
} from "./redux/config/configActions";

import {
	dataAddFilter, dataRouteChanged, dataSetDataDate, filterUpdateConditionAction
} from "./redux/data/dataActions";

import {
    userGetAuthorization
} from "./redux/user/userActions";

import { ThemeProvider, createTheme } from '@mui/material';

const { detect } = require('detect-browser');
const browser = detect();

window.Highcharts = Highcharts;
window.Highcharts.setOptions({
    lang: {
        numericSymbols: ["k" , "M" , "B" , "T" , "P" , "E"],
        thousandsSep: ',',
        rangeSelectorZoom: '',
        rangeSelectorFrom: '',
        rangeSelectorTo: '-'
    }
});



// Initialize Exporting
// NOTE: If implemented we will want to pos
// HighchartsExporting(Highcharts);
// HighchartsExportData(Highcharts);
HighchartsNoDataToDisplay(Highcharts);
HighchartsHeatmap(Highcharts);
HighchartsTreemap(Highcharts);
HighchartsWordcloud(Highcharts);
HighchartsMore(Highcharts);

// TODO: Define light/dark theme https://stackoverflow.com/questions/52379118/want-to-change-pick-primary-color-dynamically-in-material-ui-theme
// const useStyles = makeStyles(theme => ({}));

// TODO: Look into memo
export default function App() {
    // const classes = useStyles();
    const dispatch = useDispatch();
    // const theme = useTheme();

    // console.log('-----------App:render()-----------');
    // console.log(useLocation().pathname);

    // App State
    const activeRoute = useSelector(state => state.router.location.pathname);
    const appThemeLight = useSelector(state => state.persist.themeLight);
    const appModalContent = useSelector(state => state.app.modalContent);
    const auth = useSelector(state => state.auth);
    const user = useSelector(state => state.user);
    // const routes = useSelector(state => state.app.routes);
    const config = useSelector(state => state.config);
    // const data = useSelector(state =>state.data);
	const pagesFetched = useSelector(state => state.page.fetched);
    const activeRoleName = useSelector(state => state.persist.activeRoleName);
    // const persist = useSelector(state =>state.persist);

    const location = useLocation();

    // if (lightTheme) {
    //     console.log('Light Theme ->', lightTheme);
    // }

    // Component State
    const [lightTheme, setLightTheme] = useState(null);
    const [darkTheme, setDarkTheme] = useState(null);
    const [browserInfo, setBrowserInfo] = useState({
        checkingBrowser: true,
        supported: false,
    });
    const [currentRoute, setCurrentRoute] = useState(activeRoute);

    // Configuration - pass [] so there is no watch
    useEffect(() => {
        // console.log('App: UseEffect, []');

        // Global helpers
        window.dw = {
            utils: {
                _id: 0,
                mappedColors: [],
                newID: function() {
                    window.dw.utils._id++;
                    return window.dw.utils._id
                },
                newDSID: function() {
                    window.dw.utils._id++;
                    return window.dw.utils._id
                },
                cancelledDSID: []
            }
        };

        let browserSupported = false;
        switch (browser && browser.name) {
            // Browsers Tested: https://github.com/DamonOehlman/detect-browser/blob/master/test/logic.js
            case 'chrome': // Chromne
            case 'crios': // Chrome for iOS
            case 'safari': // Safari
            case 'ios': // Safari for iOS
            case 'ios-webview': //iOS WebView browser
            case 'edge': // Edge
            case 'edge-chromium': // Edge
            case 'firefox': // Firefox
            case 'fxios': // Firefox for iOS
            case 'android': // Android Webkit browser
                browserSupported = true;
                break;
            default:
                browserSupported = false;
        }

        setBrowserInfo({ checkingBrowser: false, supported: browserSupported });

        // Load up config
        if (browserSupported) {
            dispatch(configLoad());
        }
    }, []);

    useEffect(() => {
        // console.log('App: UseEffect, [config]');

        if (config.data) {
			document.title = config.data?.docTitle !== undefined ? config.data.docTitle : 'Jacobs';

            // Setup Themes
            setLightTheme(createTheme(adaptV4Theme(config.data.lightTheme)));
            setDarkTheme(createTheme(adaptV4Theme(config.data.darkTheme)));

            // Setup for AUTOMATIC Authentication (no Login button) AND check for previous login
            dispatch(authInitialize(config.data));

        }
    }, [config]);

    // useEffect(() => {
    //     console.log('App: UseEffect, [appThemeLight]');
    // }, [appThemeLight]);

    useEffect(() => {
        if (config) {
            dispatch(dataRouteChanged());
        }

    }, [activeRoute, location.search, activeRoleName]);

    // Authenticated
    useEffect(() => {
        // console.log('App: UseEffect, [authenticated]');

        if (auth.authenticated && pagesFetched) {
            dispatch(userGetAuthorization());
        }
    }, [auth.authenticated, pagesFetched]);

    // Authorized
    useEffect(() => {
        // console.log('App: UseEffect, [user.authorized]');

        if (config && user.authorized) {
            dispatch(appSetAlert('Welcome, {0}!'.format(auth.username), '', 'success', 10000));

			// Statically defined filters
            const defaultStaticFilters = config.data.defaultFilters.static;
            for (let f = 0; f < defaultStaticFilters.length; f++) {
                const refresh = (f === defaultStaticFilters.length - 1) ? true : false;
                const filter = defaultStaticFilters[f];
                dispatch(dataAddFilter("-2112", filter.field, filter.condition, filterUpdateConditionAction.REPLACE, refresh));
            }

			// Dynamic filters
			const defaultDynamicFilters = config.data.defaultFilters.dynamic;
			for (let f = 0; f < defaultDynamicFilters.length; f++) {
				const refresh = (f === defaultDynamicFilters.length - 1) ? true : false;
				const filter = defaultDynamicFilters[f];
				let values = [];

				// TYPE = projectusergroups
				// This hidden, defaultfilter will return assigned projects for Project Admins && Unnamed Users
				if (filter.type.toLowerCase() === 'projectusergroups') {
					// Super Users (Role = 1) && Contributors (Role = 2) can query all Project IDS
					// HOWEVER, (3) Project Admins can see BASIC Project Info && (0) Unnamed Users are fully data restricted, both per RLS Security Policies in the DB

					// Project Admins (Role = 3) && Unnamed Users (Role = 0) need to be filtered
					if (user.role === 3 || user.role === 0) {
						if (user.projectUserGroups.length > 0) {
							values = user.projectUserGroups.map(value => value[filter.field]);
						}

						let condition = filter.condition;
						if (filter.condition.toLowerCase() === 'inn ({0})') {
							condition = filter.condition.format(values.map(val => val).join(","));
						}
						dispatch(dataAddFilter("-2112", filter.field.toLowerCase(), condition, filterUpdateConditionAction.REPLACE, refresh, true));
					}
				}
			}

        } else if (config) {
            dispatch(appSetAlert('Yo {0}'.format(user.username ? ' {0}'.format(user.username) : '!'), 'Looks like you don\'t know the secret handshake for the application!', 'error', 10000));
        }
    }, [user.authorized]);

    // const isDataDateFound = (dataSources) => {
    //     let isFetched = false;
    //     const dataSource = dataSources.find(s => s.name.toLowerCase().trim() === 'vwdatadate');
    //     if (dataSource) {
    //         if (dataSource.data && dataSource.fetched) {
    //             isFetched = true;
    //         }
    //     }
    //     return isFetched
    // }
	//
    // useEffect(() => {
    //     if (data.dataSources.length > 0) {
    //         const dataSource = data.dataSources.find(s => s.name.toLowerCase().trim() === 'vwdatadate');
	//
    //         if (dataSource) {
    //             if (dataSource.data && data.dataDate !== dataSource.data[0].datadate) {
    //                 dispatch(dataSetDataDate(dataSource.data[0].datadate));
    //             }
    //         }
    //     }
    // }, [data.filters, isDataDateFound(data.dataSources)]);

    useEffect(() => {
        // console.log('APP -----------------> Location Change');
        // console.log(location.pathname);
        // console.log(previousRoute);      // Previous Route from App State
        // console.log(currentRoute);       // Current Route from Component State (equal to or behind Active Route)
        // console.log(activeRoute);        // Active Route from App State

        // On location.pathname change, check if App State (Active Route) has not yet triggered Component State change (currentRoute)
        // If true, go ahead and set App State with Previous Route; then update Component State with Active Route from App State
        if (currentRoute !== activeRoute) {
            if (appModalContent !== null) {
                dispatch(appSetModalContent(null));
            }
            dispatch(appSetPreviousRoute(currentRoute));
            setCurrentRoute(activeRoute);
        }
    },[location.pathname]);

    // console.log('browserInfo.supported: {0}'.format(browserInfo.supported));
    // console.log('browserInfo.checkingBrowser: {0}'.format(browserInfo.checkingBrowser));
    // console.log('auth.initialized: {0}'.format(auth.initialized));
    // console.log('auth.authenticating: {0}'.format(auth.authenticating));
    // console.log('auth.authenticated: {0}'.format(auth.authenticated));
    // console.log('user.authorized: {0}'.format(user.authorized));
    // console.log('auth.avatar: {0}'.format(auth.avatar));
    // console.log('routes.length: {0}'.format(routes.length));

    let renderAppAuthorized = false;
    if (browserInfo.supported
        && auth.authenticated
        && auth.initialized
        && user.authorized
        && auth.avatar) {
        renderAppAuthorized = true;
    }

    // let renderAppUnAuthenticated = false;
    // if (browserInfo.supported
    //     && auth.initialized
    //     && !auth.authenticating
    //     && !auth.authenticated
    //     && auth.avatar) {
    //     renderAppUnAuthenticated = false;
    // }

    let renderAppUnAuthorized = false;
    if (browserInfo.supported
        && auth.initialized
        && auth.authenticated
        && !user.authorizing
        && !user.authorized) {
        renderAppUnAuthorized = true;
    }

    let renderLoading = true;
    if (renderAppAuthorized || renderAppUnAuthorized || renderAppUnAuthorized) {
        renderLoading = false;
    }

    // console.log('** renderLoading: {0}'.format(renderLoading));
    // console.log('** renderAppAuthorized: {0}'.format(renderAppAuthorized));
    // console.log('** routes: ', routes);

    return (
        <React.Fragment>
            {(config && lightTheme && darkTheme) &&
            <React.Fragment>
                {!browserInfo.checkingBrowser && !browserInfo.supported && (
                    <UnsupportedBrowserLayout/>
                )}
                {renderAppAuthorized && (
                    <StyledEngineProvider injectFirst>
                        <ThemeProvider theme={appThemeLight ? lightTheme : darkTheme}>
                            {/*Using connected-react-router in index.js*/}
                            {/*<Router>*/}
                                <Routes/>
                            {/*</Router>*/}
                        </ThemeProvider>
                    </StyledEngineProvider>
                )}
                {/*NOTE: We're redirecting and only loading the app if the user is Authenticated*/}
                {/*making this obsolete for the time being*/}
                {/*{renderAppUnAuthenticated && (*/}
                {/*    <ThemeProvider theme={appThemeLight ? lightTheme : darkTheme}>*/}
                {/*        /!*Using connected-react-router*!/*/}
                {/*        /!*<Router>*!/*/}
                {/*            <Switch>*/}
                {/*                <Route exact path="/" component={WelcomeLayout}/>*/}
                {/*                /!*Note: This is a catch all / default route*!/*/}
                {/*                <Route path="*" component={WelcomeLayout}/>*/}
                {/*            </Switch>*/}
                {/*        /!*</Router>*!/*/}
                {/*    </ThemeProvider>*/}
                {/*)}*/}
                {renderAppUnAuthorized && (
                    <StyledEngineProvider injectFirst>
                        <ThemeProvider theme={appThemeLight ? lightTheme : darkTheme}>
                            {/*Using connected-react-router in index.js*/}
                            {/*<Router>*/}
                            <Switch>
                                <Route exact path="/" children={<UnauthorizedLayout/>}/>
                                {/*Note: This is a catch all / default route*/}
                                <Route path="*" children={<UnauthorizedLayout/>}/>
                            </Switch>
                            {/*</Router>*/}
                        </ThemeProvider>
                    </StyledEngineProvider>
                )}
                {renderLoading && (
                    <StyledEngineProvider injectFirst>
                        <ThemeProvider theme={appThemeLight ? lightTheme : darkTheme}>
                            {/*Using connected-react-router in index.js*/}
                            {/*<Router>*/}
                            <Switch>
                                <Route exact path="/" children={<AppLoading/>}/>
                                {/*Note: This is a catch all / default route*/}
                                <Route path="*" children={<AppLoading/>}/>
                            </Switch>
                            {/*</Router>*/}
                        </ThemeProvider>
                    </StyledEngineProvider>
                )}
            </React.Fragment>
            }
        </React.Fragment>
    );
}

// export default App = React.memo(App);


